var map = {
	"./arrow-right-short.svg": "76db",
	"./arrow.svg": "d4d9",
	"./arrow1.svg": "9c1b",
	"./cart.svg": "c0c3",
	"./check.svg": "4a24",
	"./clock.svg": "3175",
	"./facebook.svg": "7e4b",
	"./instagram.svg": "48d6",
	"./loader.svg": "9432",
	"./location.svg": "4093",
	"./mail.svg": "4f1b",
	"./marker.svg": "664b",
	"./pay.svg": "73d1",
	"./remove.svg": "a5b0",
	"./search.svg": "0a17",
	"./telegram.svg": "e44e",
	"./vk.svg": "b6d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";